export const FINISH_FIREWORK_ANIMATION_ACTION = 'FINISH_FIREWORK_ANIMATION_ACTION';

export const finishFireworkAnimationAction = ({ vibe }) => ({
  type: FINISH_FIREWORK_ANIMATION_ACTION,

  vibe,
});
